import {Guid} from "./api/types"

export const BLACKLIST_IDS = new Set<Guid>([
  "a9359e72-1e44-4f64-ae16-22bcc8ec04c6",  // PSR that is not in UI
] as Guid[]
)
